export var initIndicator = function (column) {
    if (column.isDisabled())
        return;
    column.getElement().querySelectorAll('.ac-column-header [data-indicator-toggle]').forEach(function (toggleElement) {
        var relatedSettings = column.getElement().querySelectorAll(".ac-column-setting[data-setting='" + toggleElement.dataset.setting + "'] .col-input .ac-setting-input:first-child input[type=radio]");
        toggleElement.addEventListener('click', function () {
            switchTo(!toggleElement.classList.contains('on'), relatedSettings);
        });
        relatedSettings.forEach(function (element) {
            element.addEventListener('change', function () {
                element.value === 'off'
                    ? toggleElement.classList.remove('on')
                    : toggleElement.classList.add('on');
            });
        });
    });
};
var switchTo = function (checked, elements) {
    var checkvalue = checked ? 'on' : 'off';
    elements.forEach(function (el) {
        if (el.value === checkvalue) {
            el.checked = true;
            el.dispatchEvent(new Event('change'));
            el.dispatchEvent(new Event('click'));
        }
    });
};
